import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingBag, Clock, History, LogOut, User, Download } from 'lucide-react';
import ConfirmationModal from '../../../components/common/Modal/ConfirmationModal';
import { usePWA } from '../../../context/PWAContext';

const CustomerBottomNavbar = ({ 
    activeView, 
    token, 
    supplierData, 
    onTabChange 
}) => {
    const navigate = useNavigate();
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
    const { promptInstall, openInstallModal, isInstalled } = usePWA();

    const handleNavigation = (view) => {
        const activeToken = token && token !== 'null' && token !== 'undefined' ? token : (localStorage.getItem('customer_token') || sessionStorage.getItem('customer_token') || '');

        if (view === 'shop') {
            if (window.location.pathname === '/shop') {
                onTabChange && onTabChange('All');
            } else {
                navigate(`/shop?token=${activeToken}&tab=All`);
            }
        } else if (view === 'pending') {
            if (window.location.pathname === '/shop') {
                onTabChange && onTabChange('Pending Orders');
            } else {
                navigate(`/shop?token=${activeToken}&tab=Pending`);
            }
        } else if (view === 'history') {
            navigate(`/status/orders?token=${activeToken}`);
        } else if (view === 'profile') {
            navigate(`/customer/profile?token=${activeToken}`);
        }
    };

    const handleLogout = () => {
        setIsLogoutModalOpen(true);
    };

    const confirmLogout = () => {
        localStorage.removeItem('customer_token');
        sessionStorage.removeItem('customer_token');
        navigate(`/order/login${supplierData?.supplierId ? `/${supplierData.supplierId}` : ''}`);
    };

    const menuItems = [
        { id: 'shop', label: 'Shop', icon: ShoppingBag },
        { id: 'pending', label: 'Pending', icon: Clock },
        { id: 'history', label: 'History', icon: History },
        { id: 'profile', label: 'Profile', icon: User }
    ];

    return (
        <>
            <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-slate-100 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] pb-safe">
                <nav className="flex justify-around items-stretch h-16 px-1">
                    {menuItems.map(item => {
                        const Icon = item.icon;
                        const isActive = activeView === item.id;

                        return (
                            <button
                                key={item.id}
                                onClick={() => handleNavigation(item.id)}
                                className={`flex-1 flex flex-col items-center justify-center gap-1 select-none transition-colors relative ${
                                    isActive ? 'text-cyan-600' : 'text-slate-400'
                                }`}
                            >
                                {isActive && (
                                    <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-[3px] bg-cyan-500 rounded-b-full shadow-sm" />
                                )}
                                <Icon 
                                    size={18} 
                                    strokeWidth={isActive ? 2.5 : 1.8} 
                                    className={`transition-transform duration-200 ${isActive ? 'scale-110 text-cyan-600' : 'text-slate-400'}`}
                                />
                                <span className={`text-[9px] font-bold tracking-wider uppercase ${isActive ? 'text-cyan-600 font-extrabold' : 'text-slate-400'}`}>
                                    {item.label}
                                </span>
                            </button>
                        );
                    })}

                    <button
                        onClick={promptInstall}
                        className="flex-1 flex flex-col items-center justify-center gap-1 select-none text-emerald-600 active:text-emerald-700 transition-colors cursor-pointer"
                        title={isInstalled ? 'App Installed' : 'Install App'}
                    >
                        <Download size={18} strokeWidth={1.8} />
                        <span className="text-[9px] font-bold tracking-wider uppercase truncate max-w-full">
                            {isInstalled ? 'Installed' : 'Install'}
                        </span>
                    </button>

                    <button
                        onClick={handleLogout}
                        className="flex-1 flex flex-col items-center justify-center gap-1 select-none text-rose-400 active:text-rose-600 transition-colors"
                    >
                        <LogOut size={18} strokeWidth={1.8} />
                        <span className="text-[9px] font-bold tracking-wider uppercase">
                            Exit
                        </span>
                    </button>
                </nav>
            </div>
            <ConfirmationModal
                isOpen={isLogoutModalOpen}
                onClose={() => setIsLogoutModalOpen(false)}
                onConfirm={confirmLogout}
                title="Exit Customer Portal?"
                message="Are you sure you want to exit the customer portal and sign out? You will need your PIN to sign back in."
                confirmText="Yes, Exit"
                cancelText="No, Keep Logged In"
                type="danger"
                icon={<LogOut className="w-6 h-6 text-red-600" />}
            />
        </>
    );
};

export default CustomerBottomNavbar;
